// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191441/js/" + chunkId + "." + {"44":"574f74a4","225":"b6484c83","481":"ca64c560","486":"d1c97315","770":"ce565fe7"}[chunkId] + ".0.1570634337655531.chunk.js";
};